
<template>

	<mymodal ref="modal" title="Импорт" ok="Импортировать" :reset="reset" :check="check" :submit="submit" :ok_hide="false">

		<b-overlay :show="wait">

			<b-form-group :state="fl_state" label="Файл" label-for="fl_input" invalid-feedback="Необходимо указать файл">
				
				<b-form-file id="fl_input" :state="fl_state" v-model="fl" placeholder="Файл" v-on:change="load_file" accept=".xlsx"/>

			</b-form-group>

			<b-form-group :state="sheet_state" label="Страница" label-for="sheet_select" invalid-feedback="Необходимо указать страницу">

				<v-select id="sheet_select" :state="sheet_state" :clearable="false" v-model="sheet" :options="wb.SheetNames" v-on:input="sheet_select" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="book_state" label="Наименование справочника УНЦС" invalid-feedback="Необходимо указать столбец">

				<v-select :state="book_state" :clearable="false" v-model="book" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="transformation_rf_state" label="Коэффициент перехода от цен базового района (Московская область) к уровню цен субъектов Российской Федерации (Кпер.)" invalid-feedback="Необходимо указать столбец">

				<v-select :state="transformation_rf_state" :clearable="false" v-model="transformation_rf" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="transformation_first_zone_state" label="Коэффициент перехода от цен первой зоны субъекта Российской Федерации к уровню цен частей территории субъектов Российской Федерации, которые определены нормативными правовыми актами высшего органа государственной власти субъекта Российской Федерации, как самостоятельные ценовые зоны (Кпер/зон" invalid-feedback="Необходимо указать столбец">

				<v-select :state="transformation_first_zone_state" :clearable="false" v-model="transformation_first_zone" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="year_state" label="Дата справочника УНЦС" invalid-feedback="Необходимо указать столбец">

				<v-select :state="year_state" :clearable="false" v-model="year" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="zone_state" label="Ценовая зона" invalid-feedback="Необходимо указать столбец">

				<v-select :state="zone_state" :clearable="false" v-model="zone" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="from_year_to_current_state" label="Переход от даты справочника к дате оценки" invalid-feedback="Необходимо указать столбец">

				<v-select :state="from_year_to_current_state" :clearable="false" v-model="from_year_to_current" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

		</b-overlay>

	</mymodal>

</template>

<script>

import XLSX from "xlsx"
import api from "../../../../api"
import mymodal from "../../../widgets/modal"

export default
{
	props :
	{
		service : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			fl : null,
			fl_state : null,

			wb : { sheets : [] },

			attrs : [],

			sheet : null,
			sheet_state : null,

			book : null,
			book_state: null,

			transformation_rf : null,
			transformation_rf_state: null,

			transformation_first_zone : null,
			transformation_first_zone_state: null,

			year : null,
			year_state : null,

			zone : null,
			zone_state : null,

			from_year_to_current : null,
			from_year_to_current_state : null,

			wait : false,

		}
	},

	methods :
	{
		reset()
		{
			this.fl = null
			this.fl_state = null
			this.sheet = null
			this.sheet_state = null
			this.book = null
			this.book_state = null
			this.transformation_rf = null
			this.transformation_rf_state = null
			this.transformation_first_zone = null
			this.transformation_first_zone_state = null
			this.year = null
			this.year_state = null
			this.zone = null
			this.zone_state = null
			this.from_year_to_current = null
			this.from_year_to_current_state = null
			this.wait = false

			this.check()
		},

		check()
		{
			this.fl_state = !! this.fl
			this.sheet_state = !! this.sheet
			this.book_state = !! this.book
			this.transformation_rf_state = !! this.transformation_rf
			this.transformation_first_zone_state = !! this.transformation_first_zone
			this.year_state = !! this.year
			this.zone_state = !! this.zone
			this.from_year_to_current_state = !! this.from_year_to_current

			return this.fl_state && this.sheet_state && this.book_state && this.transformation_rf_state && this.transformation_first_zone_state && this.year_state && this.zone_state && this.from_year_to_current_state
		},

		execute()
		{
			this.check()

			this.$refs.modal.execute()
		},

		load_file(event)
		{
			if(event.target.files)
			{
				const reader = new FileReader()
			
				reader.onload =
					event =>
					{
						const raw = event.target.result
						
						this.wb = XLSX.read(raw, { type : "binary", sheetRows : 30 })

						this.sheet = null
						this.sheet_state = null
						this.book = null
						this.book_state = null
						this.transformation_rf = null
						this.transformation_rf_state = null
						this.transformation_first_zone = null
						this.transformation_first_zone_state = null
						this.year = null
						this.year_state = null
						this.zone = null
						this.zone_state = null
						this.from_year_to_current = null
						this.from_year_to_current_state = null
						this.attrs = []

						if(this.wb.SheetNames.length)
							this.sheet_select(this.wb.SheetNames[0])

						this.wait = false
					}

				this.wait = true
				reader.readAsBinaryString(event.target.files[0])
			}
		},

		sheet_select(sheet)
		{
			this.sheet = sheet

			var attrs = []

			const ws = this.wb.Sheets[this.sheet]
			const range = XLSX.utils.decode_range(ws["!ref"])

			for(var col = range.s.c; col <= range.e.c; col++)
			{
				var cell = ws[XLSX.utils.encode_cell({ c : col, r : 0 })]

				if(cell)
					attrs.push({ name : cell.v, id : col + 1 })
			}

			this.attrs = attrs
		},

		submit()
		{
			const reader = new FileReader()

			reader.onload =
				fl =>
					api.upload_file(this, fl, this.fl.name, this.fl.name,
						response =>
						{
							var params = {

								file : response.id,
								sheet : this.sheet,
								book : this.book,
								year : this.year,
								zone : this.zone,
								cols :
								{
									transformation_rf : this.transformation_rf,
									transformation_first_zone : this.transformation_first_zone,
									from_year_to_current : this.from_year_to_current,
								}

							}

							this.wait = false

							api.call(this, this.service, "import_regional_coefs", params,
								response =>
								{
									api.delete_file(this, params.file)
									api.open_response_url(response)

									this.$emit("need_refresh")
								})

							this.$refs.modal.my_hide()
						})
					
			this.wait = true
			reader.readAsBinaryString(this.fl)
		}
	}
}

</script>

